import { type ReactNode } from 'react';

import { type AnalyticalFieldExportSettings } from 'src/core/modules/accounting-integration/apis/useAnalyticalFieldExportSettings';
import { ExportSettings } from 'src/core/modules/accounting-integration/components/ExportSettings/ExportSettings';

import {
  type InternalValue,
  type AnalyticalFieldMappingV2,
} from '../../../analyticalCodeMappings';

type Props<TField extends InternalValue> = {
  actions: ReactNode;
  fieldType: 'customField' | 'costCenter' | 'expenseCategory';
  fieldExportSetting?: AnalyticalFieldExportSettings | undefined;
  internalField: TField;
  fieldMapping: AnalyticalFieldMappingV2 | undefined;
  hasError?: boolean;
  isSplittable: boolean;
  onChange?: (settings: AnalyticalFieldExportSettings) => void;
};

export const UpdateSettings = <TField extends InternalValue>({
  actions,
  fieldType,
  fieldExportSetting,
  internalField,
  fieldMapping,
  hasError,
  isSplittable,
  onChange,
}: Props<TField>) => {
  return (
    <div className="h-full">
      <div className="bg-background-primary-default flex h-full min-h-0 flex-col">
        <div className="mx-auto min-h-0 w-[632px] flex-1 overflow-auto py-32">
          <ExportSettings
            fieldName={internalField.name}
            externalField={
              fieldMapping
                ? {
                    id: fieldMapping.externalId,
                    name: fieldMapping.externalName,
                  }
                : undefined
            }
            fieldType={fieldType}
            value={fieldExportSetting}
            hasError={hasError}
            isSplittable={isSplittable}
            onChange={(settings) => {
              onChange?.(settings);
            }}
          />
        </div>
        <div className="separator" />
        <div className="mx-auto flex w-[632px] max-w-632 items-center justify-between gap-16 p-16 px-32">
          {actions}
        </div>
      </div>
    </div>
  );
};
